// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const clients = {
  hd: {
    quote: "Автоматизация работы касс, организация работы таксопарков и агрегаторов, интеграция с банком.",
    name: "Яндекс.Такси",
    logo: "/static/icons/yandex-taxi.svg",
    photo: "bg-yandex"
  },
  tl: {
    hd: {
      quote: "Работа с курьерами ИП, внедрение расчетов, автоматизация выплат, фискализация.",
      name: "Glovo",
      logo: "/static/icons/glovo.svg",
      photo: "bg-glovo"
    },
    tl: {
      hd: {
        quote: "Автоматизация работы касс, а также автоматизация процесса выдачи чеков клиентам.",
        name: "InDriver",
        logo: "/static/icons/indriver.svg",
        photo: "bg-indriver"
      },
      tl: /* [] */ 0
    }
  }
};

function KassaCarousel(Props) {
  const match = React.useState(function () {
    return 0;
  });
  const setIdx = match[1];
  const idx = match[0];
  const match$1 = React.useState(function () {
    
  });
  const setInt = match$1[1];
  const interval = match$1[0];
  const match$2 = React.useState(function () {
    
  });
  const setRemove = match$2[1];
  const remove = match$2[0];
  const cardRef = React.useRef(null);
  const clean = function (param) {
    if (interval !== undefined) {
      clearInterval(Caml_option.valFromOption(interval));
    }
    if (remove !== undefined) {
      clearTimeout(Caml_option.valFromOption(remove));
      return;
    }
    
  };
  React.useEffect((function () {
    const cardElement = cardRef.current;
    Belt__Belt_Option.map((cardElement == null) ? undefined : Caml_option.some(cardElement), (function (el) {
      el.classList.remove("opacity-0");
      const remove = setTimeout((function (param) {
        el.classList.add("opacity-0");
      }), 4800);
      Curry._1(setRemove, (function (param) {
        return Caml_option.some(remove);
      }));
      return function (param) {
        clearTimeout(remove);
      };
    }));
    const intrvl = setInterval((function (param) {
      const nextIdx = idx + 1 | 0;
      if (nextIdx < Stdlib__List.length(clients)) {
        return Curry._1(setIdx, (function (param) {
          return nextIdx;
        }));
      } else {
        return Curry._1(setIdx, (function (param) {
          return 0;
        }));
      }
    }), 5000);
    Curry._1(setInt, (function (param) {
      return Caml_option.some(intrvl);
    }));
    return (function (param) {
      clearInterval(intrvl);
    });
  }), [idx]);
  const client = Stdlib__List.nth(clients, idx);
  const clientBg = client.photo;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        ref: cardRef,
        children: [
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("img", {
              className: "-mb-11.5 rounded-full",
              alt: "buhta",
              src: StaticAsset.src(client.logo)
            }),
            className: "w-full bg-cover bg-center flex items-end justify-center " + clientBg + " h-81.75 lg:h-110"
          }),
          JsxRuntime.jsx("p", {
            children: client.quote,
            className: "paragraph-large lg:h-light text-center text-black-landing mt-16"
          }),
          JsxRuntime.jsx("p", {
            children: client.name,
            className: "paragraph-small text-center text-black-landing mt-2"
          })
        ],
        className: "opacity-0 transition-opacity duration-150"
      }),
      JsxRuntime.jsx("div", {
        children: Belt__Belt_List.toArray(Stdlib__List.mapi((function (i, param) {
          const Key = "carousel_step_" + String(i);
          return JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("img", {
              className: i === idx ? "opacity-100" : "opacity-24",
              src: StaticAsset.src("/static/icons/step.svg")
            }),
            className: "ml-2 first:ml-0 cursor-pointer py-4",
            onClick: (function (param) {
              clean(undefined);
              Curry._1(setIdx, (function (param) {
                return i;
              }));
            })
          }, Key);
        }), clients)),
        className: "flex m-auto mt-6"
      })
    ],
    className: "flex m-auto mt-10 lg:mt-16 lg:w-200 flex-col pb-6 lg:pb-12"
  });
}

const make = KassaCarousel;

export {
  clients,
  make,
}
/* react Not a pure module */
